import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _, { get } from 'lodash';
import { Link } from 'react-router-dom';
import { useFetchCurrencyListData } from "../../../../hooks/useFetchCurrencyListData";
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import { editTenantAction, postTenantSupportedPaymentTypesAction } from '../../../../actions';
import routes from '../../../../routes';
import Table from '../../../../components/CustomTable';
import { options } from './constant'
import { isApiCallSuccess } from '../../../../selectors';

const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));

function ViewTenant(props) {
  const [stateView, setstate] = useState({});
  const [contact, setContact] = useState({});
  const [connectionManagement, setConnectionManagement] = useState(null);
  const [feeManagement, setFeeManagement] = useState(null);
  const [accountOwnerName, setAccountOwnerName] = useState(null);
  const [accountOwnerEmail, setAccountOwnerEmail] = useState(null);
  const [paymentType, setPaymentType] = useState(null);
  const currencyData = useFetchCurrencyListData();

  const { contactEmail, currencyType, isActive, contactPerson, tenantName, tenantType, user } = stateView;

  useEffect(() => {
    const { match: { params: { id } } } = props;
    if (id) {
      editId(id);
    }
  }, []);

  const fetchTenantPaymentType = async (id) => {
    const { tenantId, userId, authToken, postTenantSupportedPaymentTypesAction } = props;
    let payload = { tenantId: id };
    const { responseCode: { status }, response } = await postTenantSupportedPaymentTypesAction({ tenantId, authToken, userId, payload });
    if (isApiCallSuccess(status) && response) {
      if (response.hasOwnProperty('paymentMode')) {
        setPaymentType(response['paymentMode']['desc']);
      } else {
        setPaymentType(null);
      }
    };
  };

  const editId = async (id) => {
    try {
      const { tenantId, authToken, userId, editTenantAction, configurationList } = props;
      await fetchTenantPaymentType(id);
      let { responseCode: { status = '' }, responseList } = await editTenantAction({ tenantId, authToken, userId, editId: id });
      if (status === 'Error') { return; }
      const tenantTypeList = get(configurationList.find(currency => currency.attrName === 'TENANT_TYPE'), 'attributeValues', []);
      if (tenantTypeList && tenantTypeList.length) {
        let tenant = tenantTypeList.find((a) => a.value === responseList[0].tenantType);
        if (tenant) {
          responseList[0].tenantType = tenant.value;
        }
        if (responseList[0].hasOwnProperty('miscData')) {
          let miscData = responseList[0].miscData;
          const hasAccountOwnerName = miscData.some(obj => obj.key === 'accountOwnerName');
          const hasAccountOwnerEmail = miscData.some(obj => obj.key === 'accountOwnerEmail');
          if (hasAccountOwnerName && hasAccountOwnerEmail) {
            const accountOwnerName = miscData.find(obj => obj.key === 'accountOwnerName');
            const accountOwnerEmail = miscData.find(obj => obj.key === 'accountOwnerEmail');
            setAccountOwnerName(accountOwnerName.value);
            setAccountOwnerEmail(accountOwnerEmail.value);
          }
          const hasConnectionManagement = miscData.some(obj => obj.key === 'connectionManagement');
          const hasFeeManagement = miscData.some(obj => obj.key === 'feeManagement');
          if (hasConnectionManagement && hasFeeManagement) {
            let connectionManagementValue = miscData.find(obj => obj.key === 'connectionManagement');
            connectionManagementValue = Number(connectionManagementValue.value) ? true : false;
            let feeManagementValue = miscData.find(obj => obj.key === 'feeManagement');
            feeManagementValue = Number(feeManagementValue.value) ? true : false;
            setConnectionManagement(connectionManagementValue);
            setFeeManagement(feeManagementValue);
          }
        }
      }
      setstate(responseList[0]);
      setContact(responseList[0].contact);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="main-panel ion form__style">
      <div className="content-wrapper">
        <BreadCrumb />
        <div className="row justify-content-center mt-3">
          <div className="col-md-12 grid-margin">
            <Card>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Tenant Name  </label>
                <div class="col-md-7">
                  {tenantName}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Contact Email</label>
                <div class="col-md-7">
                  {contactEmail}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">User Name  </label>
                <div class="col-md-7">
                  {contactPerson}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Tenant Type   </label>
                <div class="col-md-7">
                  {tenantType && tenantType == 'DSP/Ad network' ? 'Agency' : tenantType}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Account Owner Name</label>
                <div class="col-md-7">
                  {accountOwnerName}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Account Owner Email</label>
                <div class="col-md-7">
                  {accountOwnerEmail}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Currency</label>
                <div class="col-md-7">
                  {currencyData && currencyData.find(item => Number(item.key) == Number(currencyType)) && currencyData.find(item => Number(item.key) == Number(currencyType)).value}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Connection Management</label>
                <div class="col-md-7">
                  {connectionManagement ? "Allowed" : "Not Allowed"}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Fee Management</label>
                <div class="col-md-7">
                  {feeManagement ? "Allowed" : "Not Allowed"}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Payment Type</label>
                <div class="col-md-7">
                  {paymentType}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Contact Number</label>
                <div class="col-md-7">
                  {contact.contactPhone}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">GST Number</label>
                <div class="col-md-7">
                  {contact.gst}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Organization Title</label>
                <div class="col-md-7">
                  {contact.organizationTitle}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Address 1 </label>
                <div class="col-md-7">
                  {contact.address1}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Address 2  </label>
                <div class="col-md-7">
                  {contact.address2}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">Country   </label>
                <div class="col-md-7">
                  {contact.country}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">State   </label>
                <div class="col-md-7">
                  {contact.state}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">City   </label>
                <div class="col-md-7">
                  {contact.city}
                </div>
              </div>
              <div class="form-group row">
                <label for="tenantName" class="col-sm-4 col-form-label">PIN   </label>
                <div class="col-md-7">
                  {contact.pinCode}
                </div>
              </div>
              <div className="col-12 px-0 pt-4 pb-2">
                <h5 className="pt-2 font-weight-bold">Access allowed to Users</h5>
              </div>

              <div className="campaign-adj">
                <div className="campaign-list-adj table-responsive">
                  <Table
                    options={options}
                    data={user || []}
                  // handelAction={this.handleActionView}
                  />
                </div>
              </div>


              <div className="form-group row mt-4">
                <div className="col-sm-12">
                  <center>
                    <Link to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.tenant.name}`}><button type="button" className="btn btn-primary">Back to Tenant</button></Link>
                  </center>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(
  (state) => ({
    configurationList: get(state, 'app.configurationData.responseList', []),
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', ''),
  }), {
  editTenantAction,
  postTenantSupportedPaymentTypesAction
}
)(ViewTenant);
